/* eslint-disable class-methods-use-this */
(() => {
  class AccordionCollection extends HTMLElement {
    constructor() {
      super();
      this.hiddenAccords = 0;
    }

    connectedCallback() {
      this.accordions = this.querySelectorAll(".js-accordion-item");

      this.accordionCount = this.accordions.length;

      this.accordions.forEach((accordion) => {
        accordion.querySelector(".js-accordion-head").addEventListener("click", () => {
          this.toggleAccordion(accordion);
        });
      });
    }

    findMatchingAccordions(searchString) {
      this.hiddenAccords = 0;

      if (searchString === "") {
        this.classList.remove("hidden");
        this.accordions.forEach((accordion) => {
          accordion.classList.remove("hidden");
        });
        return;
      }

      this.accordions.forEach((accordion) => {
        const headText = accordion.querySelector(".js-accordion-head-content").textContent.toLowerCase();
        const shouldHide = !headText.includes(searchString.toLowerCase());
        accordion.classList.toggle("hidden", shouldHide);
        if (shouldHide) this.hiddenAccords += 1;
      });

      if (this.hiddenAccords === this.accordionCount) {
        this.classList.add("hidden");
      } else {
        this.classList.remove("hidden");
      }
    }

    openAccordion(accordion) {
      const content = accordion.querySelector(".js-accordion-content");
      const head = accordion.querySelector(".js-accordion-head");
      content.style.maxHeight = `${content.scrollHeight}px`;
      accordion.classList.add("isOpen");
      head.setAttribute("aria-expanded", "true");

      if (this.dataset.scroll === "true" && window.matchMedia("(max-width: 600px)").matches) {
        setTimeout(() => {
          head.scrollIntoView({ behavior: "smooth" });
        }, 300);
      }
    }

    closeAccordion(accordion) {
      const head = accordion.querySelector(".js-accordion-head");
      const content = accordion.querySelector(".js-accordion-content");
      accordion.classList.remove("isOpen");
      head.setAttribute("aria-expanded", "false");
      content.style.maxHeight = `0`;
    }

    toggleAccordion(accordion) {
      if (accordion.classList.contains("isOpen")) {
        this.closeAccordion(accordion);
      } else {
        this.closeAllOtherAccordions(accordion);
        this.openAccordion(accordion);
      }
    }

    closeAllOtherAccordions(openAccordion) {
      this.accordions.forEach((accordion) => {
        if (!openAccordion.isEqualNode(accordion)) {
          this.closeAccordion(accordion);
        }
      });
    }
  }
  if (!customElements.get("accordion-collection")) {
    customElements.define("accordion-collection", AccordionCollection);
  }
})();
